import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <p>
          New Zealand Pure Dairy Products Limited. Unit 3, 14 Canaveral Drive,
          Rosedale, Auckland 0632, New Zealand
        </p>
        <p>Phone: +64 9 476 0028</p>
      </div>
      <div className="footer-bottom">
        <p>
          © 2025 nzpuredairy.co.nz | Website Designed by Nzpuredairy
        </p>
      </div>
    </footer>
  );
};

export default Footer;
